import { render, staticRenderFns } from "./2020year-end-article.vue?vue&type=template&id=da7fdd18&scoped=true&"
import script from "./2020year-end-article.vue?vue&type=script&lang=js&"
export * from "./2020year-end-article.vue?vue&type=script&lang=js&"
import style0 from "./2020year-end-article.scss?vue&type=style&index=0&id=da7fdd18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7fdd18",
  null
  
)

export default component.exports